import React from "react";
import { BackArrow } from "themes/Icon";
import ButtonComp from "themes/elements/Button";
import { draftValidation } from "../../helper/formValidation/formValidation";
import { isPermit } from "utils/permissionCheck";
import style from "../../create_noti.module.scss";

function Header(props) {
  const {
    handleClose,
    isEdit,
    draftLoading,
    checkValidation,
    formData,
    recipientsData,
    schedule,
    expire,
    handleSave,
    approval,
    isResubmission,
    isReadOnly = false,
    onReject,
    viewStatus,
    onChangeSchedule,
    isLoading,
  } = props;

  const showSubmitForApproval = !approval || isResubmission;

  const getTitle = () => {
    if (isReadOnly) return "Notification Details";
    if (isEdit) return "Edit notification";
    return "Create notification";
  };

  const renderButtons = () => {
    if (isReadOnly && viewStatus === 1) {
      return (
        <>
          <ButtonComp variant="secondary" onClick={handleClose}>
            Cancel
          </ButtonComp>
          <ButtonComp variant="secondary" onClick={onReject}>
            Reject
          </ButtonComp>
          <ButtonComp onClick={() => handleSave("approve")} loading={isLoading}>
            Approve
          </ButtonComp>
        </>
      );
    }

    if (isReadOnly && viewStatus === 5) {
      return (
        <>
          <ButtonComp variant="secondary" onClick={handleClose}>
            Cancel
          </ButtonComp>
          {isPermit(3, "approve_reject") && (
            <>
              <ButtonComp variant="secondary" onClick={onChangeSchedule}>
                Change Schedule
              </ButtonComp>
              <ButtonComp
                onClick={() => handleSave("publish_now")}
                loading={isLoading}
              >
                Publish Now
              </ButtonComp>
            </>
          )}
        </>
      );
    }

    if (isReadOnly && (viewStatus === 4 || viewStatus === 3)) {
      return (
        <ButtonComp variant="secondary" onClick={handleClose}>
          Cancel
        </ButtonComp>
      );
    }

    return (
      <>
        <ButtonComp onClick={handleClose} variant="secondary">
          Cancel
        </ButtonComp>
        <ButtonComp
          onClick={() =>
            draftValidation(formData, recipientsData, schedule, expire, handleSave)
          }
          variant="secondary"
          loading={draftLoading}
        >
          Save as draft
        </ButtonComp>
        <ButtonComp onClick={checkValidation}>
          {showSubmitForApproval ? "Submit for approval" : "Publish"}
        </ButtonComp>
      </>
    );
  };

  return (
    <div
      className={`flex align-center justify-between w-full ${style["header-container"]}`}
    >
      <div className="flex align-center gap-2">
        <span onClick={handleClose} className="pointer">
          <BackArrow />
        </span>
        <h2 className="page-title">{getTitle()}</h2>
      </div>
      <div className="flex wrap align-center gap-4">{renderButtons()}</div>
    </div>
  );
}

export default Header;
